'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dConditional$002dSample from "./samples.-Conditional-Sample.js";
var $p;
/** @constructor */
function $c_Lsamples_ConditionalSample$() {
}
export { $c_Lsamples_ConditionalSample$ as $c_Lsamples_ConditionalSample$ };
$p = $c_Lsamples_ConditionalSample$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_ConditionalSample$;
/** @constructor */
function $h_Lsamples_ConditionalSample$() {
}
export { $h_Lsamples_ConditionalSample$ as $h_Lsamples_ConditionalSample$ };
$h_Lsamples_ConditionalSample$.prototype = $p;
$p.b = (function() {
  return "ConditionalSample";
});
$p.Uo = (function(x$0) {
  return new $j_samples$002e$002dConditional$002dSample.$c_Lsamples_ConditionalSample(x$0.g(0));
});
$p.y = (function(p) {
  return this.Uo(p);
});
var $d_Lsamples_ConditionalSample$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_ConditionalSample$, "samples.ConditionalSample$", ({
  ou: 1,
  e: 1,
  g: 1
}));
export { $d_Lsamples_ConditionalSample$ as $d_Lsamples_ConditionalSample$ };
var $n_Lsamples_ConditionalSample$;
function $m_Lsamples_ConditionalSample$() {
  if ((!$n_Lsamples_ConditionalSample$)) {
    $n_Lsamples_ConditionalSample$ = new $c_Lsamples_ConditionalSample$();
  }
  return $n_Lsamples_ConditionalSample$;
}
export { $m_Lsamples_ConditionalSample$ as $m_Lsamples_ConditionalSample$ };
